/*
 * Dependencies:
 * - Youtube api (https://developers.google.com/youtube/iframe_api_reference?hl=fr)
 */

define('components/videofactory/views/YoutubeVideoView', [
    'components/videofactory/templates/youtubevideoview'
], function(tpl) {

    var YoutubeVideoView = Mazarine.View.extend({

        events: {},

        template: tpl,

        className: "maz-youtube-video-view",

        player: null,
        playInterval: null,

        afterRender: function() {
            this.player = new YT.Player(this.model.get('viewId'), {
                width: this.model.get('videoWidth'),
                height: this.model.get('videoHeight'),
                videoId: this.model.get('videoId'),
                playerVars: {
                    rel: this.model.get('rel'),
                    autoplay: this.model.get('autoplay'),
                    showinfo: this.model.get('showInfo'),
                    iv_load_policy: this.model.get('iv_load_policy'),
                    cc_load_policy: this.model.get('cc_load_policy'),
                    hl: this.model.get('hl'),
                    modestbranding: this.model.get('modestbranding'),
                    wmode: this.model.get('wmode')
                },
                events: {
                    onReady: _.bind(this.onReady, this),
                    onStateChange: _.bind(this.onStateChange, this)
                }
            });
        },

        destroy: function() {
            this.player.destroy();
        },

        play: function() {
            this.player.playVideo();
        },

        pause: function() {
            this.player.pauseVideo();
        },

        stop: function() {
            this.player.stopVideo();
        },

        toggleFullScreen: function() {
            console.log('TODO');
        },

        setCurrentTime: function(time, allowSeekAhead) {
            var seconds = time / 1000;
            this.player.seekTo(seconds, allowSeekAhead);
        },

        getCurrentTime: function() {
            return this.player.getCurrentTime();
        },

        getDuration: function() {
            return this.player.getDuration() * 1000;
        },

        mute: function() {
            this.player.mute();
        },

        unMute: function() {
            this.player.unMute();
        },

        onProgress: function() {
            this.model.set('currentTime', this.player.getCurrentTime() * 1000);
        },

        onReady: function() {
            this.model.set('duration', ( this.player.getDuration() * 1000 ) );

            var onReadyCallback = this.model.get('onReady');
            if (_.isFunction(onReadyCallback)) {
                onReadyCallback();
            }
        },

        onStateChange: function(state) {
            switch (state.data) {
                case 0:
                    this.onEnded();
                    break;
                case 1:
                    this.onPlay();
                    break;
                case 2:
                    this.onPause();
                    break;
                default:
                    break;
            }
        },

        onPlay: function() {
            this.playInterval = setInterval(_.bind( this.onProgress, this), 200);

            var callback = this.model.get('onPlay');
            if (_.isFunction(callback)) {
                callback();
            }
        },

        onPause: function() {
            clearInterval(this.playInterval);

            var callback = this.model.get('onPause');
            if (_.isFunction(callback)) {
                callback();
            }
        },

        onEnded: function() {
            clearInterval(this.playInterval);

            var callback = this.model.get('onEnded');
            if (_.isFunction(callback)) {
                callback();
            }
        },

        onFullscreenChange: function(e) {
            console.log('TODO');
        }
    });

    return YoutubeVideoView;
});
